import { type IconType } from '@/assets/svg';
import type { Presence, StatusType } from '@/data/UserAvailability';

export const AvatarIconSize = {
  xsm: 'w-[24px] h-[24px]',
  sm: 'w-[36px] h-[36px]',
  md: 'w-[40px] h-[40px]',
  lg: 'w-[90px] h-[90px]',
  xlg: 'w-[120px] h-[120px]',
} as const;

export type AvatarSize = keyof typeof AvatarIconSize;

export type BadgeConfig = {
  class: string;
  icon: IconType | null;
};

const BASE = 'bottom-0 right-0 rounded-full border';
const STATUS_BADGES = {
  AVAILABLE: { class: `${BASE} bg-green text-white border-white`, icon: 'Check' as IconType },
  AWAY: { class: `${BASE} bg-yellow text-white  border-white`, icon: 'Clock' as IconType },
  DND: { class: `${BASE} bg-primary text-white  border-white`, icon: 'Minus' as IconType },
  BUSY: { class: `${BASE} bg-primary border-white`, icon: null },
  HIDDEN: { class: `${BASE} bg-white text-neutral-700  border-neutral-700`, icon: 'XMark' as IconType },
  OFFLINE: { class: `${BASE} bg-white text-neutral-700  border-neutral-700`, icon: 'XMark' as IconType },
  UNKNOWN: { class: `${BASE} bg-white text-neutral-700  border-neutral-700`, icon: 'Help' as IconType },
} satisfies Record<string, BadgeConfig>;

export function computeBadgeConfig(presence?: Presence | null, userStatus?: StatusType | null): BadgeConfig {
  if (!presence) return STATUS_BADGES.UNKNOWN;
  if (presence.inCall) return STATUS_BADGES.BUSY;
  if (presence.present) {
    switch (userStatus) {
      case 'AVAIL':
        return STATUS_BADGES.AVAILABLE;
      case 'AWAY':
        return STATUS_BADGES.AWAY;
      case 'DND':
        return STATUS_BADGES.DND;
      case 'BUSY':
        return STATUS_BADGES.BUSY;
      case 'HIDDEN':
        return STATUS_BADGES.HIDDEN;
      default:
        return STATUS_BADGES.AVAILABLE;
    }
  }
  return STATUS_BADGES.OFFLINE;
}
